import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { DsCardComponent, DsIconComponent } from '@customdesignsystem';
import { PiInfoAlertComponent } from '../pi-info-alert/pi-info-alert.component';
import { PiRequirementItemComponent } from '../pi-requirement-item/pi-requirement-item.component';

/**
 * Exclusiones del paso 0 (Figma).
 */
@Component({
  selector: 'app-pi-exclusiones-card',
  standalone: true,
  imports: [
    CommonModule,
    DsCardComponent,
    DsIconComponent,
    PiInfoAlertComponent,
    PiRequirementItemComponent,
  ],
  template: `
    <ds-card
      class="pi-exclusiones-card"
      background="#ffffff"
      shadow="l2"
      gap="24px">
      <div class="pi-exclusiones__header">
        <ds-icon
          class="pi-exclusiones__header-icon"
          name="Warning"
          size="32px"
          aria-hidden="true">
        </ds-icon>
        <h2 class="pi-exclusiones__title">Este trámite no considera:</h2>
      </div>

      <div class="pi-exclusiones__panel">
        <app-pi-requirement-item
          title="Afiliados con convenio de seguridad social internacional que no residen en Chile"
          tone="warning">
          La solicitud aplica en territorio nacional.
        </app-pi-requirement-item>
      </div>

      <app-pi-info-alert title="¿Por qué no se consideran estos casos?">
        <p class="pi-exclusiones__alert-text">
          Estos casos requieren el análisis de un ejecutivo.<br />
          Si es tu caso, agenda una
          <button type="button" class="pi-info-alert__link" (click)="agendarVideoAtencion.emit()">
            Video Atención
          </button>
          para más orientación.
        </p>
      </app-pi-info-alert>
    </ds-card>
  `,
  styleUrls: ['./pi-exclusiones-card.component.scss'],
})
export class PiExclusionesCardComponent {
  @Output() agendarVideoAtencion = new EventEmitter<void>();
}
